import { useQuery } from '@tanstack/react-query';

import { valuePropsApi } from 'api/catalog/valueProps';

export const EXTERNAL_SKU_VALUE_PROPS_QUERY_KEY = 'externalSkuValueProps';

async function fetchExternalSkuValueProps(externalSku, { signal }) {
    const response = await valuePropsApi.getValuePropsForExternalSku(externalSku, { signal });
    if (!response?.status) {
        throw new Error(response?.msg ?? 'Failed to fetch value props for external SKU');
    }
    return response?.data?.valueProps ?? [];
}

/**
 * Fetches value props assigned to an external SKU.
 */
export function useExternalSkuValuePropsQuery({ enabled = true, externalSku } = {}) {
    return useQuery({
        queryKey: [EXTERNAL_SKU_VALUE_PROPS_QUERY_KEY, externalSku],
        enabled: enabled && externalSku != null,
        queryFn: ({ signal }) => fetchExternalSkuValueProps(externalSku, { signal }),
        staleTime: 60_000,
        gcTime: 5 * 60_000,
    });
}
